import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import I18n from 'components/I18n'
import iconColor from 'components/iconColor'
import FasExclamationCircle from 'components/Legacy/Icons/FasExclamationCircle'
import Link from 'components/Link'
import Text from 'components/Text'
import { ErrorType } from 'data/App/types'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { getSupportLink } from 'services/urlService'
import styled from 'styled-components'

type Props = {
  readonly error: ErrorType
  readonly onRefresh?: () => void
} & WrappedComponentProps

const Col = styled(Column)`
  padding: 2.5rem;
`

const Alert = styled(FasExclamationCircle)`
  ${iconColor('orange500')};
  margin-bottom: 1rem;
`

const Copy = styled(Text)`
  margin-bottom: 1rem;
`

const DataError = ({ error, intl, onRefresh }: Props) => (
  <Col alignItems='center'>
    <Alert />
    <Copy color='white' size='xl' weight={600}>
      <I18n data={messages.generic_data_error} />
    </Copy>
    {onRefresh && (
      <Copy color='dark300' size='md' weight={600}>
        <I18n data={messages.try_again} />
      </Copy>
    )}
    <Text color='dark300' size='sm' weight={600}>
      <I18n
        data={messages.error_contact_support}
        value={
          <Link href={getSupportLink(intl.locale)}>
            <Text color='blue600' size='sm' textTransform='lowercase' weight={600}>
              <I18n data={messages.support} />
            </Text>
          </Link>
        }
      />
    </Text>
    <Copy color='grey300' size='sm' weight={600}>
      <I18n cause={error.cause} data={messages.data_error} />
    </Copy>
    {onRefresh && (
      <CeruleanButton e2e='tryAgainButton' onClick={onRefresh}>
        <I18n data={messages.button_try_again} />
      </CeruleanButton>
    )}
  </Col>
)

export default injectIntl(DataError)
